<template>
  <b-container class="bv-example-row bv-example-row-flex-cols table-wrapper-1" fluid>
    <!--    <b-row-->
    <!--      align-v="center"-->
    <!--      class="filter-wrapper"-->
    <!--    >-->
    <!--      <b-col>-->
    <!--        <test-filter-component-->
    <!--          :status-filter.sync="statusFilter"-->
    <!--          :hospital-selected.sync="hospitalSelected"-->
    <!--          :direction-filter-selected.sync="directionFilterSelected"-->
    <!--        />-->
    <!--      </b-col>-->
    <!--    </b-row>-->
    <b-row>
      <b-table
        striped
        hover
        small
        outlined
        bordered
        show-empty
        :current-page="currentPage"
        :per-page="perPage"
        :fields="fields"
        :items="itemsFilterComputed"
      >
        <template slot="no" slot-scope="data">
          <div class="col-right">{{ $numeral((perPage*(currentPage-1)) +data.index +1).format('0,0[.]00') }}</div>
        </template>
        <template slot="hospital_name" slot-scope="data">
          <div class="col-left">{{ data.item.hospital_name }}</div>
        </template>
        <template slot="direction" slot-scope="data">
          <div class="col-left">{{ data.item.direction }}</div>
        </template>
        <template slot="name" slot-scope="data">
          <div class="col-left">{{ data.item.name }}</div>
        </template>
        <template slot="amount" slot-scope="data">
          <div class="col-right">{{ $numeral(data.item.amount).format('0,0[.]00') }}</div>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col cols="auto">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import testFilterComponent from "./testFilterComponent";
import { mapActions } from "vuex";
import * as moment from "moment";

export default {
  name: "SpecimenTable",
  components: {
    testFilterComponent
  },
  props: {
    reportType: {
      required: true
    },
    itemsFilter: {
      required: true
    },
    itemsObject: {
      required: true
    },
    dateType: {
      required: true
    },
    fromDate: {
      required: true
    },
    toDate: {
      required: true
    },
    hospitalSelected: {
      required: true
    },
    statusFilter: {
      required: true
    },
    directionFilterSelected: {
      required: true
    },
    creditTypeSelected: {
      required: true
    }
  },
  data() {
    return {
      currentPage: 1,
      perPage: 50,
      // hospitalSelected: null,
      // statusFilter: null,
      // directionFilterSelected: null,
      fields: [
        {
          key: "no",
          label: "ลำดับ"
        },
        {
          key: "hospital_name",
          label: "โรงพยาบาล"
        },
        {
          key: "direction",
          label: "เส้นทาง"
        },
        {
          key: "name",
          label: "Specimen Type"
        },
        {
          key: "amount",
          label: "จำนวน"
        }
      ]
    };
  },
  computed: {
    itemsFilterComputed: {
      get() {
        return this.itemsFilter;
      },
      set(value) {
        this.$emit("update:itemsFilter", value);
      }
    },
    totalRows() {
      return this.itemsFilterComputed.length;
    }
  },
  methods: {
    ...mapActions({
      filter: "Account/reportSpecimenFilter"
    }),
    async filters() {
      // check input informed ?
      //     let firstDate = new Date(
      //       this.fromDate.getFullYear(),
      //       this.fromDate.getMonth(),
      //       this.fromDate.getDate()
      //     );

      //  let lastDate;
      //   if (this.dateType === 'date') {
      //   lastDate = new Date(
      //     this.toDate.getFullYear(),
      //     this.toDate.getMonth(),
      //     this.toDate.getDate() + 1
      //   );
      //   } else {
      //     lastDate = new Date(
      //     this.toDate.getFullYear(),
      //     this.toDate.getMonth() + 1,
      //     0
      //   );
      //   }
      this.$store.state.isLoading = true;
      let firstDate = moment(this.fromDate);
      let lastDate = moment(this.toDate);

      if (this.dateType === "date") {
        firstDate = firstDate.startOf("days");
        lastDate = lastDate.endOf("days");
      } else if (this.dateType === "month") {
        firstDate = firstDate.startOf("months");
        lastDate = lastDate.endOf("months");
      } else if (this.dateType === "year") {
        firstDate = firstDate.startOf("years");
        lastDate = lastDate.endOf("years");
      }
      firstDate = firstDate.unix();
      lastDate = lastDate.unix();

      let result = await this.filter({
        hospital_selected: this.hospitalSelected,
        status_filter: this.statusFilter,
        date_type: this.dateType,
        from_date: firstDate,
        to_date: lastDate,
        direction_filter_selected: this.directionFilterSelected,
        credit_type_selected: this.creditTypeSelected
      });

      if (result.success) {
        this.itemsFilterComputed = result.result;
        this.$emit("update:itemsObject", result);
        this.$store.state.isLoading = false;
      } else {
        this.$bvToast.toast(`${result.errors}`, {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          variant: "danger"
        });
        this.$store.state.isLoading = false;
      }
    }
  },
  watch: {
    // dateType() {
    //   if (this.reportType === "specimenReport") {
    //     this.filters();
    //   }
    // },
    // fromDate() {
    //   if (this.reportType === "specimenReport") {
    //     this.filters();
    //   }
    // },
    // toDate() {
    //   if (this.reportType === "specimenReport") {
    //     this.filters();
    //   }
    // },
    // hospitalSelected() {
    //   if (this.reportType === "specimenReport") {
    //     this.filters();
    //   }
    // },
    // statusFilter() {
    //   if (this.reportType === "specimenReport") {
    //     this.filters();
    //   }
    // },
    // directionFilterSelected() {
    //   if (this.reportType === "specimenReport") {
    //     this.filters();
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  background: #eaeced;
  padding: 1rem;
}

.table-wrapper-1 {
  padding: 0 3rem 3rem 3rem;
}
</style>
